'use strict';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const AnimGsap = {
    init: function () {

        const animateLineBlocks = document.querySelectorAll('.js-animated');
        this.addClassOnScroll(animateLineBlocks, 'anim-visible', 'top center');

        const titles = document.querySelectorAll('.h2');
        this.addClassOnScroll(titles, 'appear', 'top 60%');
    },

    addClassOnScroll: function (ArraySelectors, classToAdd, startApparitionPosition) {
        gsap.registerPlugin(ScrollTrigger);
        if (ArraySelectors.length > 0) {
            ArraySelectors.forEach(el => {
                gsap.to(el, {
                    scrollTrigger: {
                        trigger: el,
                        start: startApparitionPosition,
                        // toggleClass: classToAdd,
                        // markers: true
                        onEnter: () => {
                            el.classList.add(classToAdd)
                        }
                    }
                })
            })
        }
    }
};

export default AnimGsap;
